export const API_reminder_series = (): string => '/api/reminder-series';
export const API_reminder_series_single = (seriesId: string): string =>
  `/api/reminder-series/${seriesId}`;
export const API_reminder_series_delete = (seriesId: string, reminderId?: string): string =>
  `/api/reminder-series/${seriesId}${reminderId ? '?reminderId=' + reminderId : ''}`;
